const styles = (theme) => ({
  notificationContainer: {
    minHeight: 100,
    padding: 10,
  },
  notificationIconContainer: {
    textAlign: "center",
  },
  notificationIcon: {
    color: theme.palette.primary.main,
    fontSize: 34,
  },
  title: {
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    fontWeight: "700",
    lineHeight: "18px",
    marginBottom: 8,
  },
  subtitle: {
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    lineHeight: "16px",
    marginBottom: 8,
  },
  time: {
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    lineHeight: "18px",
    opacity: "0.7",
  },
  link: {
    color: theme.notificationLinkColor,
    fontWeight: "700",
  },
  info: {
    display: "flex",
    flexDirection: "column",
  },
  outerContainer: {
    cursor: "pointer",
    width: '100%',
    "&:not(:last-child)": {
      borderBottom: `1px solid ${theme.scrollThumbColor}`,
    },
    "&:only-child": {
      borderBottom: `1px solid ${theme.scrollThumbColor}`,
    },
    "&:hover": {
      backgroundColor: theme.tooltipBGColor,
    },
  },
});

export default styles;
